import Swiper from 'swiper/bundle';

export default function initSliderCourses() {
	document.querySelectorAll(".slide-courses-container").forEach(slide => {
		const nextButton = slide.querySelector(".swiper-button-next");
		const prevButton = slide.querySelector(".swiper-button-prev");

		const swiper = new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 32,
			grabCursor: 'true',

			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			}
		});
	});
}

if (document.querySelectorAll(".slide-courses-container")) {
	initSliderCourses();
}
